/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const feedTranslationSchema = z.object({
  lang: z.string(),
  title: z.string().nullable().optional(),
  definition: z.string(),
  usageNote: z.string().nullable().optional(),
  examples: z.array(z.string().nullable()),
});

export type IFeedTranslation = z.infer<typeof feedTranslationSchema>;
